// Billing uses v2 directly. Existing screens retain their response shapes; prices and eligibility stay on the server.
import { requestV2 } from './v2-only.ts'
import { receiptDetailsFields } from '../receipt-details.js'

const sides = () => import('./billing-v2.ts')

export const gemPrices = (token: string | null) =>
  requestV2(sides, (api) => api.gemPrices(token, {}))

export const buyGems = (
  token: string,
  gemId: string,
  provider: 'card' | 'crypto',
) => requestV2(sides, (api) => api.checkout(token, {}, { gemId, provider }))

export const planPrices = (token: string | null) =>
  requestV2(sides, (api) => api.plans(token, {}))

export const buyPlanByCard = (
  token: string,
  plan: string,
  cycle: 'monthly' | 'yearly',
  _abValue?: string,
) =>
  requestV2(sides, (api) =>
    api.checkout(token, {}, { plan, term: cycle, provider: 'card' }),
  )

export const buyPlanByCrypto = (token: string, plan: string) =>
  requestV2(sides, (api) =>
    api.checkout(token, {}, { plan, term: 'monthly', provider: 'crypto' }),
  )

export const orderHistory = (token: string) =>
  requestV2(sides, (api) => api.orders(token, {}))

export const downloadReceipt = (token: string, orderId: string) =>
  requestV2(sides, (api) => api.receipt(token, {}, orderId))

export const getReceiptDetails = (token: string) =>
  requestV2(sides, (api) => api.receiptDetails(token, {}))

/** Details stay in the PUT body; a refusal never retries them through a legacy GET query. */
export const saveReceiptDetails = (
  token: string,
  details: Record<string, string>,
) =>
  requestV2(sides, (api) =>
    api.saveReceiptDetails(token, {}, receiptDetailsFields(details)),
  )

export const redeemCode = (token: string, code: string) =>
  requestV2(sides, (api) => api.redeem(token, {}, code))

export const declinedNotice = (token: string | null) =>
  token
    ? requestV2(sides, (api) => api.declined(token, {}))
    : Promise.resolve(null)

export const clearDecline = (token: string) =>
  requestV2(sides, (api) => api.dismissDeclined(token, {}))

export const serverStatus = (token: string) =>
  requestV2(sides, (api) => api.serverStatus(token, {}))

/** The survey still only records answers; cancellation stays at the provider. */
export const cancelContext = (token: string, _enroll = false) =>
  requestV2(sides, (api) => api.cancelContext(token, {}))

export const cancelReason = (token: string, reason: string, detail?: string) =>
  requestV2(sides, (api) => api.cancelReason(token, {}, reason, detail))

export const cancelFollowUp = (
  token: string,
  id: string,
  fields: CancelFollowUp,
) => requestV2(sides, (api) => api.cancelFollowUp(token, {}, id, fields))

export type CancelFollowUp = {
  missing_features?: string[]
  missing_features_detail?: string
  discount_response?: 'yes' | 'no'
  rescue_target?: 'explore' | 'discord'
}
